import resolveChannelAltEntry from './resolveChannelAltEntry';

/**
 * Resolves display state of shared channel Alt for one listing.
 */
export default function resolveSharedMediaAltState(asset, listingId) {
  const listingKey = String(listingId);
  const entry = resolveChannelAltEntry(asset, listingId);

  const usedByProduct = (asset?.products || []).some((link) => String(link._id) === listingKey);
  const usedByVariants = (asset?.productVariants || [])
    .filter((link) => String(link.productId) === listingKey)
    .map((link) => link.variantId);

  return {
    publishedAlt: entry?.published ?? null,
    pendingAlt: entry?.pending ? entry.pending.value : null,
    draftBaselineAlt: entry?.draftBaseline ?? null,
    hasPending: Boolean(entry?.pending),
    pendingOwner: entry?.pending
      ? { type: entry.pending.ownerType, id: entry.pending.ownerId }
      : null,
    usedByProduct,
    usedByVariants,
  };
}
